import React from 'react';
import { PinPointIcon, ShopIcon } from '../../../utils/svg';

const DeliveryLocation = ({ orderDetails = {} }) => {
  const orderType = orderDetails?.request_post_datas?.availabilityName?.toLowerCase()
	return (
    <div className={`px-4 ${orderType === "pickup" && 'hidden'}`}>
			<div className='flex items-center'>
        <ShopIcon className="fill-[var(--rose-violet)]" />
				<div className='ml-3'>
					<p className='text-xs text-gray-500 font-normal'>Lokasi Restoran</p>
					<p className='text-sm text-gray-800 font-semibold pt-1'>{orderDetails?.orderItems?.[0]?.storeName}</p>
				</div>
			</div>
			<div className='flex items-center my-5'>
        <PinPointIcon className="fill-[var(--rose-violet)] min-w-7 w-7 h-auto" />
				<div className='ml-3 w-full pr-10'>
					<p className='text-xs text-gray-500 font-normal'>Lokasi Pengantaran</p>
					<p className='text-sm text-gray-800 font-semibold truncate pt-1'>{orderDetails?.address}</p>
				</div>
			</div>
		</div>
	);
}

export default DeliveryLocation;
